import { createFileRoute } from "@tanstack/react-router";

import { BASE_COLOR } from "~/components/feature/balance/components/BalanceCurrentLiabilities";
import { DetailPage } from "~/components/feature/shared/components/DetailPage";

export const Route = createFileRoute(
  "/_app/dashboard/balance/current-liabilities/$category/detail",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category } = Route.useParams();

  return (
    <DetailPage
      tab="current-liabilities"
      category={category}
      targetMetric="balance"
      baseColor={BASE_COLOR}
    />
  );
}
